var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionOutArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34348 14.1543L12.3632 4.1346L12.3703 9.20455H14.3643V0.719273H5.87901V2.71331L10.949 2.72039L0.929264 12.7401L2.34348 14.1543Z",
    fill: "#B40E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionOutArrow);
export default __webpack_public_path__ + "static/media/transaction-out-arrow.db8f900bb713dd9bd89177444e98b9d9.svg";
export { ForwardRef as ReactComponent };